<template>
  <div class="speakers-page pt-3 pb-4 page-container">
    <div class="title d-flex align-items-center mb-2">
      <div class="row w-100">
        <div class="col-12 col-md-4 col-xl-3">
          <h3 class="mr-2 w-100 w-md-auto">{{ $_t('KW:magideiShiur') }}</h3>
        </div>
        <div class="col-auto">
          <b-input-group class>
            <b-form-input :placeholder="$_t('KW:search')" v-model="filterMagidShiur"></b-form-input>
            <b-input-group-text :slot="isRTL ? 'prepend' : 'append'">
              <i class="fa fa-search"></i>
            </b-input-group-text>
          </b-input-group>
        </div>
      </div>
    </div>
    <b-tabs
      class="magidei-tabs"
      @input="
        index => {
          activeTab = index == 0 ? 'shas-magidei-shiur' : index == 1 ? 'all-magidei-shiur' : 'mishna-magidei-shiur';
        }
      "
      lazy
    >
      <b-tab :title="$_t('KW:hadafBeiyunShiur')" :active="activeTab === 'shas-magidei-shiur'">
        <magidei-list type="shas" :magidei-shiur="shas"></magidei-list>
      </b-tab>
      <b-tab :title="$_t('KW:allMagideiShiur')" :active="activeTab === 'all-magidei-shiur'">
        <magidei-list type="torah" :magidei-shiur="torah"></magidei-list>
      </b-tab>
      <b-tab :title="$_t('KW:mishnaMagideiShiur')" :active="activeTab === 'mishna-magidei-shiur'">
        <magidei-list type="mishna" :magidei-shiur="mishna"></magidei-list>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import MagideiListComponent from './magideiShiur/magideiList.vue';
export default {
  metaInfo: function() {
    return {
      title: this.metaTitle,
      meta: [{ name: 'description', content: this.metaDescription }],
    };
  },
  components: {
    MagideiList: MagideiListComponent,
  },
  data: function() {
    return {
      filterMagidShiur: null,
      magideiShiur: {
        shas: null,
        torah: null,
        mishna: null,
      },
      error: null,
      loading: null,
      activeTab: this.getActiveTab(),
    };
  },
  mounted: function() {
    if (Object.keys(this.$store.state.api.speakers).length === 0) {
      this.$store.dispatch('api/loadSpeakers').then(() => this.getData());
    } else {
      this.getData();
    }
  },
  watch: {
    filterMagidShiur(newVal) {
      let tabsWithData = [];
      if (this.torah.length != 0) tabsWithData.push('all-magidei-shiur');
      if (this.shas.length != 0) tabsWithData.push('shas-magidei-shiur');
      if (this.mishna.length != 0) tabsWithData.push('mishna-magidei-shiur');

      console.log('TAB', this.activeTab);

      if (tabsWithData.length > 0 && !tabsWithData.includes(this.activeTab)) {
        this.activeTab = tabsWithData[0];
      }
    },
  },
  computed: {
    metaTitle: function() {
      return `${this.getTitle()} Magidei Shiur`;
    },
    metaDescription: function() {
      return this.$_t('KW:site.metaWithName', { name: `${this.getTitle()} Magidei Shiur` });
    },
    shas: function() {
      if (!this.filterMagidShiur) {
        return this.magideiShiur.shas;
      }
      var searchRegex = new RegExp(this.filterMagidShiur, 'i');
      return this.magideiShiur.shas.filter(function(magidShiur) {
        return searchRegex.test(magidShiur.name);
      });
    },
    torah: function() {
      if (!this.filterMagidShiur) {
        return this.magideiShiur.torah;
      }
      var searchRegex = new RegExp(this.filterMagidShiur, 'i');
      return this.magideiShiur.torah.filter(function(magidShiur) {
        return searchRegex.test(magidShiur.name);
      });
    },
    mishna: function() {
      if (!this.filterMagidShiur) {
        return this.magideiShiur.mishna;
      }
      var searchRegex = new RegExp(this.filterMagidShiur, 'i');
      return this.magideiShiur.mishna.filter(function(magidShiur) {
        return searchRegex.test(magidShiur.name);
      });
    },
  },
  methods: {
    getActiveTab() {
      let type = this.$route.query.type;
      if (type) {
        if (type == 'all-magidei-shiur') {
          return 'all-magidei-shiur';
        } else if (type == 'mishna-magidei-shiur') {
          return 'mishna-magidei-shiur';
        }
      }
      return 'shas-magidei-shiur';
    },
    getTitle() {
      if (this.activeTab === 'all-magidei-shiur')
        return 'Torah';
      else if (this.activeTab === 'mishna-magidei-shiur')
        return 'Mishna';
      else
        return 'Shas';
    },
    getData: function() {
      this.error = this.magideiShiur.shas = this.magideiShiur.torah = this.magideiShiur.mishna = null;
      this.magideiShiur = this.$store.state.api.speakers;
    },
  },
};
</script>

<style lang="scss" scoped>
.speakers-page {
  .title {
    div {
      // flex-grow: 1;
      input {
        border-radius: 1.25rem 0 0 1.25rem;
        border-right: none;
        padding-left: 1.25rem;
      }
      .input-group-append .input-group-text {
        max-width: 3.125rem;
        border-radius: 0 1.25rem 1.25rem 0;
        border-left: none;
        background: none;

        .fa {
          font-size: 1.1rem;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.speakers-page {
  .nav-tabs {
    border-bottom: 2px solid $dark-blue;
    .nav-link {
      // border-radius: 0.625rem 0.625rem 0px 0.625rem;
      padding: 0.9375rem 2.5rem;
      font-size: 1rem;
      color: $dark-blue;
      font-weight: bold;
      border-bottom-color: $dark-blue;
      background-color: $bg-gray;
      text-transform: uppercase;
    }
    .nav-link.active {
      background-color: $dark-blue;
      border-color: $dark-blue;
      color: $white;
    }
    .nav-item a:not(.active):hover {
      background: $secondary;
    }
  }
}
</style>
